import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { ErrorCodes } from '../__generated__/auth-gate';
export { isGqlError, isPxError, isApwError };
export var ServerError = /*#__PURE__*/function (_Error) {
  _inherits(ServerError, _Error);
  function ServerError(message, code, apiName) {
    var _this;
    _classCallCheck(this, ServerError);
    _this = _callSuper(this, ServerError, [message]);
    _defineProperty(_assertThisInitialized(_this), "message", void 0);
    _defineProperty(_assertThisInitialized(_this), "apiName", void 0);
    _defineProperty(_assertThisInitialized(_this), "extensions", void 0);
    _this.message = message;
    _this.apiName = apiName;
    _this.extensions = {
      code: code
    };
    return _this;
  }
  return _createClass(ServerError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export function getError(e) {
  var _e$response;
  var errors = e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.errors;
  if (isPxGqlError(e.response)) {
    return new PxError(e);
  }
  if (!errors) {
    e.criticalError = true;
    return e;
  }
  var error = errors[0];
  error.apiName = e.apiName;
  if (isApwError(error)) {
    if (error.extensions.apw_error.error == ErrorCodes.mfa_required) {
      return new MfaRequiredError(error);
    }
    return new ApwError(error);
  }
  return new GqlError(error);
}
export function getSdkError(message, code, apiName) {
  var error = new ServerError(message, code, apiName);
  return new GqlError(error);
}
export var GqlError = /*#__PURE__*/function (_Error2) {
  _inherits(GqlError, _Error2);
  function GqlError(e) {
    var _this2;
    _classCallCheck(this, GqlError);
    _this2 = _callSuper(this, GqlError, [e.message]);
    _defineProperty(_assertThisInitialized(_this2), "error_type", void 0);
    _defineProperty(_assertThisInitialized(_this2), "code", void 0);
    _defineProperty(_assertThisInitialized(_this2), "criticalError", void 0);
    _defineProperty(_assertThisInitialized(_this2), "apiName", void 0);
    _defineProperty(_assertThisInitialized(_this2), "extensions", void 0);
    _this2.extensions = e.extensions;
    _this2.code = _this2.extensions.code;
    _this2.apiName = e.apiName;
    _this2.criticalError = !!_this2.extensions.shouldRetry;
    _this2.error_type = 'GqlError';
    return _this2;
  }
  return _createClass(GqlError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var ApwError = /*#__PURE__*/function (_GqlError2) {
  _inherits(ApwError, _GqlError2);
  function ApwError(error) {
    var _this3;
    _classCallCheck(this, ApwError);
    _this3 = _callSuper(this, ApwError, [error]);
    _defineProperty(_assertThisInitialized(_this3), "description", void 0);
    _defineProperty(_assertThisInitialized(_this3), "criticalError", void 0);
    _defineProperty(_assertThisInitialized(_this3), "payload", void 0);
    _this3.code = error.extensions.apw_error.error;
    _this3.description = error.extensions.apw_error.error_description;
    _this3.criticalError = !!_this3.extensions.shouldRetry;

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    _this3.payload = error.extensions.apw_error;
    return _this3;
  }
  return _createClass(ApwError);
}(GqlError);
export var MfaRequiredError = /*#__PURE__*/function (_ApwError2) {
  _inherits(MfaRequiredError, _ApwError2);
  function MfaRequiredError(error) {
    var _this4;
    _classCallCheck(this, MfaRequiredError);
    _this4 = _callSuper(this, MfaRequiredError, [error]);
    _defineProperty(_assertThisInitialized(_this4), "mfaPayload", void 0);
    _this4.mfaPayload = {
      email: error.extensions.apw_error.email,
      uuid: error.extensions.apw_error.uuid,
      mfa_token: error.extensions.apw_error.mfa_token
    };
    return _this4;
  }
  return _createClass(MfaRequiredError);
}(ApwError);
export var PxError = /*#__PURE__*/function (_Error3) {
  _inherits(PxError, _Error3);
  function PxError(e) {
    var _this5;
    _classCallCheck(this, PxError);
    _this5 = _callSuper(this, PxError, ['px_error']);
    _defineProperty(_assertThisInitialized(_this5), "appId", void 0);
    _defineProperty(_assertThisInitialized(_this5), "jsClientSrc", void 0);
    _defineProperty(_assertThisInitialized(_this5), "firstPartyEnabled", void 0);
    _defineProperty(_assertThisInitialized(_this5), "uuid", void 0);
    _defineProperty(_assertThisInitialized(_this5), "hostUrl", void 0);
    _defineProperty(_assertThisInitialized(_this5), "blockScript", void 0);
    _defineProperty(_assertThisInitialized(_this5), "apiName", void 0);
    _defineProperty(_assertThisInitialized(_this5), "criticalError", void 0);
    _defineProperty(_assertThisInitialized(_this5), "error_type", void 0);
    var res = e.response;
    _this5.appId = res.appId;
    _this5.jsClientSrc = res.jsClientSrc;
    _this5.firstPartyEnabled = res.firstPartyEnabled;
    _this5.uuid = res.uuid;
    _this5.hostUrl = res.hostUrl;
    _this5.blockScript = res.blockScript;
    _this5.apiName = e.apiName;
    _this5.criticalError = false;
    _this5.error_type = 'px_error';
    return _this5;
  }
  return _createClass(PxError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
function isApwError(e) {
  return 'apw_error' in e.extensions;
}
function isPxError(err) {
  return 'error_type' in err && err.error_type == 'px_error';
}
function isPxGqlError(res) {
  return res && res.appId && res.jsClientSrc;
}
function isGqlError(e) {
  return 'error_type' in e && e.error_type == 'GqlError';
}